import React, { useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import RequiredDocumentsModal from '../../Modals/documents/RequiredDocuments'
import { classesEventStore } from 'state/classes/classesStore'

const RequiredDocuments: React.FC = () => {
  const [documentModalVisible, setDocumentModalVisible] =
    useState<boolean>(false)
  const { selectedRequiredDocumentIds } = classesEventStore(store => ({
    selectedRequiredDocumentIds: store.selectedRequiredDocumentIds,
  }))
  return (
    <>
      <div onClick={() => setDocumentModalVisible(true)}>
        <IconsTextNavigation
          iconName="FilePlus"
          heading="Required documents"
          isCompleted={selectedRequiredDocumentIds.length > 0 ? true : false}
        />
      </div>
      {documentModalVisible && (
        <RequiredDocumentsModal
          openModal={documentModalVisible}
          closeModal={setDocumentModalVisible}
        />
      )}
    </>
  )
}

export default RequiredDocuments
